import Api from 'libs/api/index';

class SiteCategories extends Api {
  constructor() {
    super('admin/site_categories/');
  }
}

export default SiteCategories;
